import { normalize } from "normalizr";
import { get } from "../api/status-page-api";
import { externalServicesIncidentsSchema } from "./status-page-schema";
import { SET_EXTERNAL_SERVICES_INCIDENT, SET_EXTERNAL_SERVICES_INCIDENTS } from "./status-page-mutations";
export const LOAD_EXTERNAL_SERVICES_STATUS = "LOAD_EXTERNAL_SERVICES_STATUS";
const serviceCache = {};
const CACHE_EXPIRY_MS = 60 * 60 * 1000;
const actions = {
  [LOAD_EXTERNAL_SERVICES_STATUS]: async (context, service) => {
    const now = Date.now();
    const cacheKey = service || "all";
    const cached = serviceCache[cacheKey];
    if (cached && now - cached.timestamp < CACHE_EXPIRY_MS) {
      const {
        entities,
        result
      } = cached;
      const mutationToCall = service ? SET_EXTERNAL_SERVICES_INCIDENT : SET_EXTERNAL_SERVICES_INCIDENTS;
      context.commit(mutationToCall, {
        externalServicesIncidents: {
          byId: entities.externalServicesIncidents || {},
          allIds: result
        },
        service
      });
      return;
    }
    const {
      externalServices
    } = await get(service);
    const {
      entities,
      result
    } = normalize(externalServices, [externalServicesIncidentsSchema]);
    serviceCache[cacheKey] = {
      entities,
      result,
      timestamp: now
    };
    const mutationToCall = service ? SET_EXTERNAL_SERVICES_INCIDENT : SET_EXTERNAL_SERVICES_INCIDENTS;
    context.commit(mutationToCall, {
      externalServicesIncidents: {
        byId: entities.externalServicesIncidents || {},
        allIds: result
      },
      service
    });
  }
};
export default actions;